import { OAUTH_RESERVED_PARAMETERS } from '@utils/constants/auth'

/**
 * Get the redirect URI by removing OAuth reserved parameters from the current URL.
 *
 * @returns {string}
 */
const getRedirectUri = () => {
  const URI = new URL(window.location)
  const redirectLocation = window.location.origin
    ? window.location.origin + window.location.pathname
    : window.REDIRECT_URI

  OAUTH_RESERVED_PARAMETERS.forEach(parameter => URI.searchParams.delete(parameter))

  return URI.searchParams.toString()
    ? [redirectLocation, URI.searchParams.toString()].join('?')
    : redirectLocation
}

/**
 * Redirect to the cleaned redirect URI.
 *
 * @returns {void}
 */
const doRedirect = () => {
  window.location.href = getRedirectUri()
}

/**
 * The cleaned redirect URL.
 *
 * @type {string}
 */
const redirectURL = getRedirectUri()

export { doRedirect, getRedirectUri, redirectURL }
